// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1eVuD","inputWrap":"styles_inputWrap__1md8f","input":"styles_input__DfxSj"};